import i18n from "@/i18n";
import React from "react";
import Api, { CommentParentType } from "@/api";
import { showErrorToast } from "turboui";
import { compareIds } from "@/routes/paths";

export function useEditComment<T extends { id?: string | null; content?: any }>(
  comments: T[],
  setComments: React.Dispatch<React.SetStateAction<T[]>>,
  parentType: CommentParentType,
  invalidateCache: () => void,
) {
  const handleEditComment = React.useCallback(
    async (commentId: string, content: any) => {
      const comment = comments.find((c) => c.id && compareIds(c.id, commentId));

      try {
        const nextContent = JSON.stringify(content ?? {});

        if (comment) {
          setComments((prev) => prev.map((c) => (compareIds(c.id, commentId) ? { ...c, content: nextContent } : c)));
        }

        await Api.comments.update({
          commentId,
          parentType,
          content: nextContent,
        });

        invalidateCache();
        return true;
      } catch (error) {
        if (comment) {
          setComments((prev) => prev.map((c) => (compareIds(c.id, commentId) ? { ...comment } : c)));
        }
        showErrorToast(i18n.t("Error"), i18n.t("Failed to edit comment."));
        return false;
      }
    },
    [comments, parentType, invalidateCache, setComments],
  );

  return {
    handleEditComment,
  };
}
